// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qjj0","left":"styles_left__1_hok","desktopActions":"styles_desktopActions__3S6SC","title":"styles_title__3nMLr"};